
namespace Matrix.Indexation {

    @Serenity.Decorators.registerClass()
    export class FactIndexConstituentRorDialog extends SiteEntityDialog<FactIndexConstituentRorRow, any> {
        protected getFormKey() { return FactIndexConstituentRorForm.formKey; }
        protected getIdProperty() { return FactIndexConstituentRorRow.idProperty; }
        protected getLocalTextPrefix() { return FactIndexConstituentRorRow.localTextPrefix; }
        protected getNameProperty() { return FactIndexConstituentRorRow.nameProperty; }
        protected getService() { return FactIndexConstituentRorService.baseUrl; }
        protected getDeletePermission() { return FactIndexConstituentRorRow.deletePermission; }
        protected getInsertPermission() { return FactIndexConstituentRorRow.insertPermission; }
        protected getUpdatePermission() { return FactIndexConstituentRorRow.updatePermission; }

        protected form = new FactIndexConstituentRorForm(this.idPrefix);

    }
}